import React from 'react';
import { ContentTemplate, TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';

import { EmailAlertMessage } from '../../modules/profile/components/EmailAlertMessage';

const AccountCreationEmailAlert = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('profile->>EmailAlertMessage.Account Created')} />

      <ContentTemplate>
        <EmailAlertMessage />
      </ContentTemplate>
    </>
  );
};

export default AccountCreationEmailAlert;
